import {get} from 'lodash';

export default (state = {}, {customer_id, data}: any) => {
  return {
    ...state,
    bodyMeasurementsData: {
      ...get(state, 'bodyMeasurementsData', {}),
      [customer_id]: data,
    },
  };
};
